import {
  HttpClient,
  HttpEventType,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { catchError, filter, firstValueFrom, map, Observable, of } from 'rxjs';
import { LoaderService } from '../components/loader/loader.service';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(
    private _httpClient: HttpClient,
    private _loader: LoaderService,
  ) {}

  readonly documentAdded = signal(0);

  notifyDocumentAdded() {
    this.documentAdded.set(this.documentAdded() + 1);
  }

  async uploadFileToS3(presignedUrl: string, file: File, contentType: string) {
    return await firstValueFrom(
      this._httpClient.put(presignedUrl, file, {
        headers: new HttpHeaders({
          'Content-Type': contentType,
        }),
      }),
    );
  }

  downloadFileFromPresignedUrl(url: string, fileName: string) {
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response error.');
        }
        return response.blob();
      })
      .then((blob) => {
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(objectUrl);
        this._loader.setShowLoader = false;
      });
  }
}
